import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

export const ErrorPage = () => {
    return (
        <div className='w-full h-[20vh] flex items-center justify-center flex-col'>
            <div className='flex items-center mb-6 '>
                <FontAwesomeIcon
                    icon={faTriangleExclamation}
                    className='text-icons-danger text-2xl mr-2'
                />
                <span className='text-icons-danger text-2xl'>Error</span>
            </div>

            <div className='text-texts-secondary300 font-semibold'>
                Unable to load progress of telegram bot integration with your
                repository
            </div>
        </div>
    );
};
